import { _ as e } from "./extends-093996c9.js";
import t from "react";

var c = function c(_c) {
  var l = _c.blue,
      r = void 0 === l ? "#18283f" : l,
      h = _c.white,
      a = void 0 === h ? "white" : h,
      i = _c.schema,
      s = {
    isotypebox: a,
    isotypeletter: r,
    letters: r
  };
  return "light" === (void 0 === i ? "common" : i) && (s.isotypebox = r, s.isotypeletter = a, s.letters = a), t.createElement("svg", e({
    version: "1.1",
    id: "latercera-am",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.3 85.5"
  }, _c), t.createElement("g", {
    id: "latercera"
  }, t.createElement("g", null, t.createElement("rect", {
    x: "1.3",
    y: "10.3",
    fill: s.isotypebox,
    width: "45.8",
    height: "42.8"
  }), t.createElement("path", {
    fill: s.isotypeletter,
    d: "M0,8.5v46.2h48.3V8.5H0z M23.7,46.3H5.9V16.9h4.6v25.3h13.2V46.3z M42.4,21h-8.7v25.3h-4.6V21h-8.7v-4.1 h22.1L42.4,21L42.4,21z"
  })), t.createElement("polygon", {
    fill: s.letters,
    points: "118.6,16.5 131.1,16.5 131.1,52.6 137.7,52.6 137.7,16.5 150.2,16.5 150.2,10.6 118.6,10.6 \t"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M214.6,26.7c0-9.7-6.4-16-17.9-16h-10.8v42h6.6v-10h4.1c1.1,0,2.1-0.1,3-0.2l7.2,10.2h7.8l-8.5-11.9 C211.7,38.1,214.6,33.1,214.6,26.7z M196.4,36.9h-3.9V16.5h3.9c8,0,11.3,3.8,11.3,10.2C207.8,33.1,204.5,36.9,196.4,36.9z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M238.7,47.2c-8.4,0-14.6-6.5-14.6-15.6c0-8.9,6.1-15.6,14.4-15.6c5.6,0,9.1,2,11.9,5.7l5.1-3.6 c-3.6-5.1-9-8.1-16.8-8.1c-12,0-21.4,9.1-21.4,21.5S226.6,53,238.5,53c8.1,0,13.6-2.8,18-8.6l-5.1-3.5 C248.2,45.1,244.2,47.2,238.7,47.2z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M320,26.7c0-9.7-6.4-16-17.9-16h-10.7v42h6.6v-10h4.1c1,0,2.1-0.1,3-0.2l7.2,10.2h7.8l-8.5-11.9 C317.1,38.1,320,33.1,320,26.7z M301.8,36.9h-3.9V16.5h3.9c8,0,11.4,3.8,11.4,10.2S309.9,36.9,301.8,36.9z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M340.2,9.7h-0.4l-18.4,42.8h6.7l2.4-5.9h18.8l2.4,5.9h7L340.2,9.7z M333,40.9l7-16.6l6.9,16.6H333z"
  }), t.createElement("polygon", {
    fill: s.letters,
    points: "260,52.6 287.4,52.6 287.4,46.7 266.7,46.7 266.7,39.6 284.5,39.6 284.5,33.9 266.7,33.9 266.7,16.5 287.4,16.5 287.4,10.6 260,10.6 \t"
  }), t.createElement("polygon", {
    fill: s.letters,
    points: "160.9,39.6 178.8,39.6 178.8,33.9 160.9,33.9 160.9,16.5 181.9,16.5 181.9,10.6 154.3,10.6 154.3,52.6 181.9,52.6 181.9,46.7 160.9,46.7 \t"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M100.1,9.8l-15.9,37H67.5V10.6h-6.6v42h27.5l2.4-5.9h18.8l2.4,5.9h7L100.5,9.8H100.1z M93.2,40.9l7-16.6 l6.8,16.6H93.2z"
  })), t.createElement("g", {
    id: "am"
  }, t.createElement("path", {
    fill: s.letters,
    d: "M374.6,55.1c0.1,0,1-0.5,2.5-2.8c2.1-3.1,3.3-6.5,4.7-9.9c5.3-13.2,10.7-26.5,16-39.7 c0.1-0.3,0.2-0.5,0.4-1c0.2,0.5,0.4,0.8,0.5,1.1c6.2,14.5,12.5,29,18.7,43.4c1.4,3.3,3.2,6.5,5.9,9c0.4,0.4,0.9,0.7,1.4,1.1 c-8.1,0-16.1,0-24.3,0c0.2-0.2,0.4-0.3,0.6-0.3c3.6-1.6,4.9-4.3,3.8-8c-0.7-2.3-1.7-4.6-2.6-6.8c-0.1-0.2-0.5-0.4-0.7-0.4 c-5.8,0-11.6,0-17.3,0c-0.3,0-0.7,0.3-0.8,0.6c-0.8,2-1.7,4-2.4,6c-1.4,3.9-0.1,6.8,3.6,8.6c0.2,0.1,0.4,0.2,0.9,0.5 c-3.8,0-7.4,0-11,0L374.6,55.1L374.6,55.1z M392.9,17.7c-3,7.5-5.8,14.6-8.7,21.9c5.9,0,11.7,0,17.6,0 C398.8,32.3,395.9,25.1,392.9,17.7z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M490,3c-1.1,1-2.2,1.7-3.1,2.7c-1.5,1.7-2.3,3.7-2.3,6c0,11.9-0.1,23.9,0,35.8c0,3.8,1.9,6.6,5.1,8.5 c0.1,0.1,0.2,0.1,0.5,0.3c-7.8,0-15.5,0-23.2,0c0.8-0.6,1.7-1.1,2.4-1.8c2.2-2,3.2-4.5,3.2-7.4c0-12.7,0-25.4,0-38 c0-0.1,0-0.2-0.1-0.5c-6.6,16.1-13.2,31.9-19.8,48c-6.8-15.4-13.4-30.6-20.1-45.7c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.7,0,1 c0,11.5,0,23,0,34.5c0,4.4,1.8,7.7,5.8,9.7c0.1,0,0.1,0.1,0.3,0.3c-4.3,0-8.6,0-12.9,0c0.6-0.4,1.1-0.7,1.6-1.1 c2.5-1.8,3.9-4.3,4-7.4c0.1-12.1,0.1-24.2,0-36.3c0-3.5-1.9-6.3-5-8c-0.2-0.1-0.4-0.2-0.5-0.5c0.3,0,0.5,0,0.8,0 c4.9,0,9.7,0,14.6,0c0.7,0,1,0.2,1.2,0.8c5.1,11.8,10.2,23.6,15.3,35.4c0.1,0.3,0.3,0.7,0.5,1.2c0.2-0.4,0.3-0.7,0.4-1 c4.9-11.8,9.8-23.7,14.7-35.5c0.3-0.6,0.6-0.9,1.3-0.9C479.6,3.1,484.8,3,490,3z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M384.5,72.4c0.6,0,1.2-0.5,1.2-1.2v-3c0-0.6-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v3 C383.3,71.8,383.8,72.4,384.5,72.4z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M376.3,75.1c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3c0.5-0.5,0.5-1.2,0-1.7l-2.1-2.1 c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7L376.3,75.1z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M391.8,75.4c0.3,0,0.6-0.1,0.8-0.3l2.1-2.1c0.5-0.5,0.5-1.2,0-1.7s-1.2-0.5-1.7,0l-2.1,2.1 c-0.5,0.5-0.5,1.2,0,1.7C391.2,75.3,391.5,75.4,391.8,75.4z"
  }), t.createElement("path", {
    fill: s.letters,
    d: "M397.9,80.4h-5.8c-0.6-3.7-3.8-6.5-7.6-6.5s-7,2.8-7.6,6.5h-5.8c-0.6,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2 h5.7h15.4h5.7c0.6,0,1.2-0.5,1.2-1.2S398.5,80.4,397.9,80.4z M379.2,80.4c0.5-2.4,2.7-4.2,5.2-4.2s4.7,1.8,5.2,4.2H379.2z"
  }), t.createElement("circle", {
    opacity: "0.5",
    fill: s.letters,
    cx: "436.6",
    cy: "77.5",
    r: "2.8"
  }), t.createElement("circle", {
    opacity: "0.5",
    fill: s.letters,
    cx: "481",
    cy: "77.5",
    r: "2.8"
  })));
};

export { c as LaTerceraAM };